import { productCardTemplate } from "../templates";
var ProductCard = Backbone.View.extend({
    tagName: 'div',
    className: 'col-12 col-md-4 col-lg-3',
    events: {
        'click a.example-hider' : 'exampleRemove',
        'click .download-button' : 'showDownloadsList',
        'mouseenter div.product-card': 'maybeCancelHideDownloads',
        'mouseleave div.product-card': 'maybeHideDownloads'
    },
    initialize: function( options ){
        this.filters = typeof options.filters !== 'undefined' ? options.filters : null;
        _.bindAll( this, 'render', 'showDownloadsList', 'checkVisibility', 'hideDownloadsList', 'maybeHideDownloads', 'maybeCancelHideDownloads' );

        this.downloadsOpen = false;
        this.render();
    },
    render: function(){
        let x = this.model.toJSON(); //this.getActiveCardSettings();
        // console.log( x );
        let html = productCardTemplate( x );
        this.el.innerHTML = html;
    },
    hideDownloadsList: function(){
        clearTimeout( this.hideTimeout );
        this.hideTimeout = false;
        this.downloadsOpen = false;
        this.$('.image-wrap').removeClass( 'show-downloads' );
    },
    maybeHideDownloads: function(){
        if ( this.downloadsOpen ) {
            this.hideTimeout = setTimeout(this.hideDownloadsList, 500);
        }
    },
    maybeCancelHideDownloads: function(){
        if ( this.downloadsOpen && this.hideTimeout ) {
            clearTimeout( this.hideTimeout );
        }
    },
    showDownloadsList: function( e ){
        e.preventDefault();
        e.stopPropagation();
        this.downloadsOpen = true;
        this.$('.image-wrap').addClass( 'show-downloads' );
    },
    checkVisibility: function(){

        let visible = this.model.get('visible');
        if ( !visible ) {
            this.remove();
        }
    }
});
export {ProductCard};